import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {CampusDesignCategory} from '../DesignSelector/CampusDesignCategory';
import {CampusDesignCard} from '../DesignSelector/CampusDesignCard';
import {CampusDesignSelector} from '../DesignSelector/CampusDesignSelector';
import {CampusFooter} from '../Components/CampusFooter';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';
import {CampusHeader} from '../Components/CampusHeader';
import { CampusFeedback } from './CampusFeedback';

const DIVISION: string = 'Campus';

const searchStyle : CSSProperties = {
    fontFamily: 'AveriaSerifLightItalic',
    fontSize: '12px',
    letterSpacing: '6px',
    backgroundColor:'white',
    textAlign: 'center',
    border: '1px solid #CCCCCC',
    padding: '3px 0 3px 7px',
    textTransform: 'uppercase',
    width: '400px',
    height:'25px',
    alignSelf:'center'
};
const selectorStyle : CSSProperties = {
    position: 'position',
    display: 'flex',
    zIndex: 2,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    top:'10%',
};

const catalogStyle : CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flexGrow: 2,
    overflowY: 'auto',
    justifyContent:'center',
    marginTop:'20px',
};
const contentDiv: CSSProperties = {
    margin:'30px auto 0px auto',
    display:'flex',
    flexDirection:'column'
}
const addToProofBtn: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#D7D7D7',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#626262',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Reitam'
}

const designHdr: CSSProperties = {
    fontFamily:"AveriaSerifRegular",
    textTransform:"uppercase",
    fontSize:'25px',
    color:'rgb(97, 96, 96)',
    textAlign:'center'
}

let submitBtnStyle : CSSProperties = {
    backgroundColor:'#E27558',
    color:'white',
    width:'529px',
    height:'49px',
    margin:'auto',
    textAlign:'center',
    lineHeight:'2.0em',
    fontFamily:'Reitam',
    cursor:'pointer',
    border:'1px solid transparent',
    ':hover': {
        backgroundColor:'white',
        color:'#E27558',
        border:'1px solid grey'
    }
}
const submitButton : CSSProperties = {
    width:'125px',
    height:'30px',
    backgroundColor:'#E27558',
    margin:'5px auto 0px',
    cursor:'pointer',
    display:'none',
    textAlign:'center',
    fontFamily:"Reitam",
    color:'white',
    lineHeight:'30px',
    padding: '2px 0 2px 0px',
}
const searchDiv: CSSProperties = {
    display: 'flex',
    justifyContent:'center',
    flexDirection:'column'
}
const clearBtn: CSSProperties = {
    fontFamily:'Reitam',
    width:'125px',
    backgroundColor:'#E9E6E6',
    height:'30px',
    lineHeight:'30px',
    textAlign:'center',
    padding: '2px 0 2px 0px',
    margin:'5px auto 0px',
    cursor:'pointer',
    color:'#616060'
}
const btnDiv: CSSProperties = {
    display:'flex',
}

type StateType = {
    filter: string,
    design: Tgcc.Design,
    zoomDesign: Tgcc.Design,
    Designs: Tgcc.Design[],
    isWaiting: boolean,
}

class _CampusSearch extends React.Component<Tgcc.BaseProps, any>{

 openDesign = () => {browserHistory.push(Tgcc.Routes.CampusDesignListView)};
 openKeyword = (keyword:string) => {browserHistory.replace(Tgcc.Routes.CampusSearchKeyword(keyword))};

 componentWillMount() {
        document.body.style.overflow = 'hidden';
        this.clearState();
        if(!this.props.state.ActiveProof){
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof()});
        }
    }
 componentDidMount(){
        var tag = document.getElementById('designPage');
        tag.scrollIntoView(false);
        var keyword  = this.props.location.query.keyword
        if(keyword != null){
            this.filterDesignsBySearch(keyword)
        }
 }
 scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
}

    state: StateType = {
        filter: null,
        design: null,
        zoomDesign: null,
        Designs: null,
        isWaiting: false,
    }

    clearState = () => {
        this.setState({
            filter: null,
            design: null,
            zoomDesign: null,
            Designs: null,
            isWaiting:false});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByCategory, payload: null})
    }


    DesignsLoaded(Designs : Tgcc.Design[]) {
        for(var i in Designs)
            Designs[i].displayIndex = Number(i);
        this.setState({Designs: Designs,isWaiting:false});
    }

    DesignsVisible: boolean = false;
    getDesignItems() {
        this.DesignsVisible = false;
       
        var Designs = new Array();
        var noItemStyle1: CSSProperties = { 
            fontFamily: 'AveriaSerifLight', 
            fontSize:'24px', 
            textAlign: 'center', 
            width: '100%', 
            textTransform: 'uppercase', 
            color:'rgb(97, 96, 96)',
            marginTop:'50px',
            marginBottom:'200px',
        };
        var no: CSSProperties = {marginBottom:'20px'}

        if((this.state.filter) && this.state.Designs){
            if(this.state.Designs.length == 0){
                Designs.push( <div key="none" style={noItemStyle1}>No matching items</div>);
            } 

            for(var i in this.state.Designs){
                var design: Tgcc.Design = this.state.Designs[i];
                Designs.push(<CampusDesignCard key={design.id} design={design} onSelect={this.handleDesignSelection} onZoom={this.handleZoom}/>);
            }
            this.DesignsVisible = true;
        } else {
            var chooseSomething = (<div key="none" style={noItemStyle1} onClick={this.openDesign}><div style={no}>Need more ideas?</div><div style={submitBtnStyle} className='campusCatDesign'>Search by our Categories</div></div>);
            Designs.push(chooseSomething);
        }

        return Designs;
        
    }

    handleBackToProof = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None})
    }

    handleZoom = (design: Tgcc.Design) => {
        this.setState({zoomDesign:design});
    }

    handleDesignSelection = (design : Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateCampusProofDesign, payload: design});
    }

    selectedImageStyle: CSSProperties = {
         display: 'flex',
         width: '200px',
         alignSelf: 'center',
         cursor: 'zoom-in'
    }


    handleDetailBackButton = () => {
        this.setState( { design: null});
    }

    handleTextSearch = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.keyCode == 13){ // return keyCode
            this.filterDesignsBySearch(evt.currentTarget.value.toLowerCase());
        }

        var style = evt.currentTarget.attributes['style'];
        if(style && style.value){
            if(evt.currentTarget.value)
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 6px','letter-spacing: 1px');
            else
                evt.currentTarget.attributes['style'].value = style.value.replace('letter-spacing: 1px','letter-spacing: 6px');
        }
    }

    handleTextSearchBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
        var srch = evt.currentTarget as HTMLInputElement;
        var srchComp = !srch.value ? null : srch.value.toLowerCase(); // make sure "" is set to null
        if(this.state.filter != srchComp){
            this.filterDesignsBySearch(srch.value);
        }
    }

    filterDesignsBySearch(filter: string){
        filter = filter && filter.length ? filter : null;
        this.setState({filter: filter, Designs: null});
        this.openKeyword(filter);
        TgccRequest.getDesignsFiltered(DIVISION,filter, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs));
        if(this.state.isWaiting === true){
            this.setState({isWaiting:false})
        }else {
            this.setState({isWaiting:true});
        }
    }
    get = () => {
        if(this.state.filter) {
            this.filterDesignsBySearch(this.state.filter.toLowerCase());
        }
    }
    clear = () => {
        this.setState({filter:null});
        document.getElementById('search')['value'] = ''
    }
    mobileCheck() {
        return (
                <div style={searchDiv}>   
                        <input type="text" id="search" className='campusSearch' style={searchStyle} placeholder="Search" onBlur={this.handleTextSearchBlur} onKeyUp={this.handleTextSearch} />
                    <div style={btnDiv}>
                        <div onClick={this.clear} style={clearBtn}>Clear</div>
                        <div onClick={this.get} className="srchBtnCampus" style={submitButton}>Submit</div>
                    </div>
                </div>
        )               
    }

    render() {

        var searchBlock = this.mobileCheck();
        var designs = this.state.isWaiting ? <Tgcc.LoadingElement /> : this.getDesignItems() 
        return (
                    <div key="1" style={selectorStyle}>
                    <div id='designPage'></div>
                        <CampusHeader />
                        <CampusFeedback state={this.props.state} />
                        <div style={designHdr} className="campusheader">Search our entire design gallery</div>
                        <div style={contentDiv} className="campusDesign2Box">  
                            {searchBlock}
                            <div style={catalogStyle} className="campusLogStyle">
                                {designs}
                           </div>
                            {this.getZoomedDesign()}
                            </div>
                          <CampusFooter state={this.props.state}/>
                       </div>
                )
    }



    getZoomedDesign = () =>  {
        if(!this.state.zoomDesign)
            return (<a/>);

       let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center',
            width: '600px',
            height: '800px',
            maxWidth: '90%',
            maxHeight: '75%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            }
           
       };

        let imgStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '80%',
            maxHeight: '75%',
            display: 'block',
            alignSelf: 'center',
            cursor: 'zoom-out'
        };

        let screenDoor: CSSProperties = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22,22,22,0.5)',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden'
        }        
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
        }
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }
        return ( 
            <ScreenDoor>
                <div style={fullSizeStyle} className="fullSizeStyle">
                    <CloseX closeAction={this.hideZoom} />
                    <img src={Tgcc.getDesignPath(this.state.zoomDesign.image)} style={imgStyle} onError={Tgcc.handleDesignImageError} onClick={this.hideZoom}/> 
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.handlePrev}>&lsaquo;</div>
                        <div className="grayButton" style={addToProofBtn} onClick={this.handleZoomAdd}>add to proof</div>
                        <div style={arrowStyle} onClick={this.handleNext}>&rsaquo;</div>
                    </div>  
                </div>
            </ScreenDoor>
        )
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    hideZoom = () => {
        this.setState({zoomDesign: null});
    }

    handleZoomAdd = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        if(this.props.state.LoginData && this.props.state.UserInfo){
            this.handleDesignSelection(this.state.zoomDesign);
        } else
        {
            browserHistory.push(Tgcc.Routes.CampusRegister)
        }
    }

    handlePrev = (evt: React.MouseEvent<HTMLDivElement>) =>{
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex-1;
        curIndex = curIndex < 0 ? this.state.Designs.length - 1 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }

    handleNext = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex+1;
        curIndex = curIndex >= this.state.Designs.length ? 0 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }
}
  
const mapStateToProps = (state : Tgcc.GlobalState ) => {
    return {state:state}
};

export var CampusSearch = connect(mapStateToProps)(Radium(_CampusSearch));